'use client'

import React, { useEffect, useRef, useState } from 'react'
import BookingSkeleton from '@/components/BookingSkeleton'
import { useQueryState } from 'nuqs'

const BookingWidget = () => {
  const [loading, setLoading] = useState(true)
  const widgetRef = useRef<HTMLDivElement>(null)

  // nuqs for params
  const [arrival] = useQueryState('casaarrival')
  const [departure] = useQueryState('casadeparture')
  const [adults] = useQueryState('casaadults')

  useEffect(() => {
    // Remove any previous scripts (for hot reloads)
    document.querySelectorAll('script[data-casa-blanca]').forEach((s) => s.remove())

    // Inject head.js
    const headScript = document.createElement('script')
    headScript.src = 'https://frontend.casablanca.at/Scripts/headjs/head.js?Customer=AT_ANTON_GRI'
    headScript.setAttribute('data-casa-blanca', 'true')
    headScript.onload = () => {
      // After head.js loads, inject main.js
      const mainScript = document.createElement('script')
      mainScript.src = 'https://frontend.casablanca.at/widgets/main.js?Customer=AT_ANTON_GRI'
      mainScript.setAttribute('data-casa-blanca', 'true')
      document.body.appendChild(mainScript)
    }
    document.body.appendChild(headScript)

    // Wait for widget to load
    const interval = setInterval(() => {
      const widget = widgetRef.current
      if (widget && widget.children.length > 1) {
        setLoading(false)
        clearInterval(interval)
      }
    }, 300)
    return () => clearInterval(interval)
  }, [])

  return (
    <div>
      {loading && <BookingSkeleton />}
      <div
        ref={widgetRef}
        className="casa-wdg"
        data-casa-widget-type="IBE"
        data-customer="AT_ANTON_GRI"
        data-company="COMP1"
        data-language="de"
        {...(arrival ? { 'data-casa-arrival': arrival } : null)}
        {...(departure ? { 'data-casa-departure': departure } : null)}
        {...(adults ? { 'data-casa-adults': adults } : null)}
        style={{ display: loading ? 'none' : undefined, }}
      />
    </div>
  )
}

export default BookingWidget
